import React, { useContext, useMemo, useState, useEffect } from "react";
import { PaymentContext, IsEmbeddedPage } from "../../App";
import EmbeddedLayout from "../EmbeddedLayout";
import CheckoutLayout from "../CheckoutLayout";

const Layout = ({ children }) => {
  const payment = useContext(PaymentContext);
  const [isEmbbedded, setIsEmbbedded] = useState();
  useEffect(() => {
    const timer = setTimeout(() => setIsEmbbedded(payment ? true : false), 3000);
    return () => clearTimeout(timer);
  }, [payment]);
  
  return (
    <>
      {(isEmbbedded === true) && (
        <EmbeddedLayout>{children}</EmbeddedLayout>
      )}

      {(isEmbbedded === false) && (
        <CheckoutLayout>{children}</CheckoutLayout>
      )}
    </>
  )
}

export default Layout
